import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createDepartmentApi,
  getDepartmentApi,
  updateDepartmentApi,
} from "./departmentApi";

export const getDepartmentRequest = createAsyncThunk(
  "getDepartmentRequest/department",
  async () => {
    try {
      const response = await getDepartmentApi();
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const createDepartmentRequest = createAsyncThunk(
  "createDepartmentRequest/department",
  async (payload: any) => {
    try {
      const response = await createDepartmentApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const updateDepartmentRequest = createAsyncThunk(
  "updateDepartmentRequest/department",
  async (payload: any) => {
    try {
      const response = await updateDepartmentApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  departmentList: any[];
  departmentPost: any;
  departmentUpdate: any;
  message: string;
  isSuccess: boolean;
  pageIsLoading: boolean;
}

const initialState: IInitialState = {
  departmentList: [],
  departmentPost: {},
  departmentUpdate: {},
  message: "",
  isSuccess: false,
  pageIsLoading: false,
};

const departmentSlice = createSlice({
  name: "department",
  initialState: initialState,
  reducers: {
    resetMessageDepartment: (state) => {
      state.message = "";
    },
    resetSuccessDepartment: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers(builder) {
    // get department reducer
    builder.addCase(getDepartmentRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getDepartmentRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.departmentList = action.payload.data;
        state.pageIsLoading = false;
      } else {
        // state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getDepartmentRequest.rejected, (state) => {
      state.pageIsLoading = false;
    });

    // create department reducer
    builder.addCase(createDepartmentRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(createDepartmentRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.departmentPost = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(createDepartmentRequest.rejected, (state) => {
      state.message = "someting went wrong";
      state.pageIsLoading = false;
    });

    // update department reducer
    builder.addCase(updateDepartmentRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateDepartmentRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.departmentUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateDepartmentRequest.rejected, (state) => {
      state.message = "someting went wrong";
      state.pageIsLoading = false;
    });
  },
});

export const { resetMessageDepartment, resetSuccessDepartment } =
  departmentSlice.actions;
export default departmentSlice.reducer;
